import { AccountRatesDialogTab } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.component'
import { UniversalPlusMenuItem } from '@tv3/layout/navbar/global-plus-btn/universal-plus-menu'
import {
  OpenAddDiscountCodeDialog,
  OpenAddExportCalendarDialog,
  OpenAddInquiryOverlay,
  OpenAddLosDiscountDialog,
  OpenAddRateDialog,
  OpenAddSharingCalendarDialog,
  OpenChannelAutomationDialog,
  OpenGapNightAutomationDialog,
  OpenGroupRateDialog,
  OpenImportCalendarDialog,
  OpenLastMinuteAutomationDialog,
  OpenMinStayAutomationDialog,
  OpenRateAutomationDialog,
} from '@tv3/store/overlay/overlay.actions'
import { OpenAddHoldDialog } from '@tv3/store/overlay/overlay.actions'

export const calendarPlusMenu: UniversalPlusMenuItem[] = [
  {
    icon: 'cs-icon cs-icon-file-plus text-indigo text-xxxl fa-fw',
    label: 'Add Inquiry',
    description: 'Manually create a new  inquiry',
    action: OpenAddInquiryOverlay({ params: {} }),
  },
  {
    icon: 'cs-icon cs-icon-calendar-arrow-down text-info text-xxxl fa-fw',
    label: 'Import Calendar',
    description: 'Import an external iCal URL and add those events to your calendar.',
    action: OpenImportCalendarDialog(),
  },
  {
    icon: 'cs-icon cs-icon-calendar-plus4 text-success text-xxxl fa-fw',
    label: 'Add Booking',
    description: 'Manually create a new booking',
    action: OpenAddInquiryOverlay({ params: { isBooking: true, title: $localize`Add Booking` } }),
  },
  {
    icon: 'cs-icon cs-icon-calendar-arrow-up text-danger text-xxxl fa-fw',
    label: 'Export Calendar',
    description: 'Export an internal iCal URL and add those events to your calendar.',
    action: OpenAddExportCalendarDialog({}),
  },
  {
    icon: 'cs-icon cs-icon-calendar-pause3 text-warning text-xxxl fa-fw',
    label: 'Add Hold Event',
    description: 'Block dates on your calendar and make them unavailable for booking.',
    action: OpenAddHoldDialog({}),
  },
  {
    icon: 'cs-icon cs-icon-calendar-share2 text-success text-xxxl fa-fw',
    label: 'Share Calendar',
    description: 'Share your calendar with external persons via a webpage.',
    action: OpenAddSharingCalendarDialog(),
  },
  {
    icon: 'cs-icon cs-icon-money-plus text-indigo text-xxl fa-fw mr-1',
    label: 'Add Standard Rate',
    description: 'Set a fixed nightly price that remains constant over time.',
    action: OpenAddRateDialog({ data: { type: 'standard' } }),
  },
  {
    icon: 'cs-icon cs-icon-dollar-sync text-success text-xxl fa-fw mr-1',
    label: 'Add Dynamic Rate',
    description: 'Dynamic rates auto-adjust with occupancy and update channels instantly.',
    action: OpenAddRateDialog({ data: { type: 'dynamic' } }),
  },
  {
    icon: 'cs-icon cs-icon-ai text-primary text-5xl fa-fw',
    hoverIcon: 'cs-icon cs-icon-ai-solid text-primary text-5xl fa-fw',
    label: 'Smart Rate Automation',
    description: 'Optimize pricing with dynamic, automated rate adjustments for better revenue and occupancy.',
    bg: 'bg-secondary-primary',
    action: OpenRateAutomationDialog({ data: { activeTab: AccountRatesDialogTab.ChannelAutomations } }),
    submenu: [
      {
        icon: 'cs-icon cs-icon-net-dollar text-success text-xxxl fa-fw',
        label: 'Channel Rate Automation',
        description: 'Automatically update and push rates to rentals and API channels.',
        action: OpenChannelAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-building-dollar text-info text-xxxl fa-fw',
        label: 'Group Rates',
        description: 'Apply rate changes to multiple rentals at once.',
        action: OpenGroupRateDialog({ data: { activeTab: AccountRatesDialogTab.GroupRates } }),
      },
      {
        icon: 'cs-icon cs-icon-los-discount2 text-warning text-xxxl fa-fw',
        label: 'LOS Discount',
        description: 'Adjust rates based on the guest’s length of stay.',
        action: OpenAddLosDiscountDialog(),
      },
      {
        icon: 'cs-icon cs-icon-discount-code2 text-indigo text-md',
        label: 'Discount Code',
        description: 'Offer special discounts for Webready bookings.',
        action: OpenAddDiscountCodeDialog(),
      },
      {
        icon: 'cs-icon cs-icon-bed2 text-danger text-xl',
        label: 'Min Night Stay',
        description: 'Set the minimum nights required for each day.',
        action: OpenMinStayAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-calendar-alt3 text-success text-xxxl fa-fw',
        label: 'Gap Night',
        description: 'Adjust pricing for booking gaps between reservations.',
        action: OpenGapNightAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-calendar-dollar text-primary text-xxxl fa-fw',
        label: 'Dynamic Rate',
        description: 'Rates adjust automatically based on occupancy.',
        action: OpenAddRateDialog({ data: { type: 'dynamic' } }),
      },
      {
        icon: 'cs-icon cs-icon-time-counter2 text-danger text-xxxl fa-fw',
        label: 'Last Minute Automation',
        description: 'Change nightly rates for upcoming last-minute stays.',
        action: OpenLastMinuteAutomationDialog({}),
      },
    ],
  },
]
